import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CartComponentStore } from 'cart-data';
import {
  ItemComponentBase,
  ItemResultRenderTarget,
  ItemResultRenderTargetComponents,
  RenderInItemResultLayoutDirective,
} from 'products-ui';
import { CartItemQuantitySelectorComponent } from '../../../../common/cart-item-quantity-selector';

@Component({
  selector: 'ideal-standard-item-result-layout-components-provider',
  imports: [RenderInItemResultLayoutDirective, CartItemQuantitySelectorComponent],
  standalone: true,
  templateUrl: './standard-item-result-layout-components-provider.component.html',
  styleUrl: './standard-item-result-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CartComponentStore],
})
export class StandardItemResultLayoutComponentsProviderComponent extends ItemComponentBase {
  protected readonly LayoutTargets = ItemResultRenderTarget;
  protected readonly LayoutComponents = ItemResultRenderTargetComponents;
}
